<script lang="ts">
  import { onMount } from "svelte"

  // import { scrollIntoView } from "./scroll-into-view"

  export let length = 0
  export let selected = 0

  let container: HTMLElement
  let observer: IntersectionObserver

  onMount(() => {
    length = container.children.length
  })

  onMount(() => {
    observer = new IntersectionObserver(
      (entries) => {
        for (const { target, isIntersecting } of entries)
          if (isIntersecting) selected = Array.prototype.indexOf.call(container.children, target)
      },
      { threshold: 0.5 },
    )

    for (const child of container.children) observer.observe(child)

    return () => observer.disconnect()
  })

  // $: if (container && observer) {
  //   observer.disconnect()

  //   scrollIntoView(container.children[selected]).then(() => {
  //     for (const child of container.children) observer.observe(child)
  //   })
  // }
</script>

<div bind:this={container}>
  <slot />
</div>

<style lang="postcss">
  * {
    @apply isolate flex h-full w-full snap-x snap-mandatory gap-[inherit] overflow-y-auto;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      @apply hidden;
    }

    & > :global(*) {
      @apply h-full w-full shrink-0 snap-center;
    }
  }

  @supports (animation-timeline: scroll(inline)) {
    * > :global(*:nth-child(2)) {
      z-index: -2;

      & > :global(*) {
        animation: 1ms swipe2 linear forwards;
        animation-timeline: scroll(inline);

        @keyframes swipe2 {
          0% {
            transform: translateX(-100%) scale(0.85);
            opacity: 0.3;
          }
          50% {
            transform: translateX(0%) scale(1);
            opacity: 1;
          }
          100% {
            transform: translateX(0%);
          }
        }
      }
    }

    * > :global(*:nth-child(3)) {
      z-index: -3;

      & > :global(*) {
        animation: 1ms swipe3 linear forwards;
        animation-timeline: scroll(inline);

        @keyframes swipe3 {
          0%,
          50% {
            transform: translateX(-100%) scale(0.85);
            opacity: 0;
          }
          50.001% {
            transform: translateX(-100%) scale(0.85);
            opacity: 0.3;
          }
          100% {
            transform: translateX(0%) scale(1);
            opacity: 1;
          }
        }
      }
    }
  }
</style>
